import React from 'react';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { Spacer } from '../components/spacer';
import { WrapperItem } from '../components/wrapper-item';
export class SectionSpacer extends React.Component {
    render() {
        const { section, cssClass } = this.props;
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { padding: "0", borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, borderBottom: section.borderBottom },
                React.createElement(Column, null,
                    React.createElement(Spacer, { cssClass: cssClass, height: `${section.height}px`, containerBackgroundColor: section.backgroundColor })))));
    }
}
//# sourceMappingURL=section-spacer.js.map